import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';

import PostSearchControls from '../post-list-search-controls';
import PostActions from '../post-list-actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
    listActionBar: {
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
  }),
);

export default function PostListActionBar(props: any) {
  const classes = useStyles(baseTheme);

  return props.editEnabled ?
    (
      <Grid item container className={classes.listActionBar}>
        <PostSearchControls editEnabled={true} />
      </Grid>
    ) : (
      <Grid item container className={classes.listActionBar}>
        <PostSearchControls />
        <PostActions />
      </Grid>
    );
}
